export function mapObject<T, R>(object: { [key: string]: T }, fn: (item: T) => R): { [key: string]: R } {
  return Object.entries(object).reduce((c, [key, value]) => {
    c[key] = fn(value)
    return c
  }, {})
}
